/*
 * @Descripttion: 人员审核、
 * @version: 
 * @Author: wl
 * @Date: 2020-06-15 17:46:09
 * @LastEditors: wl
 * @LastEditTime: 2020-06-15 17:48:35
 */ 
import axios from '../axios'


//人员审核、
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_person_list',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/personReview.js